import { Button, IButtonProps } from "@/components/Button";
import { downloaderBuilder } from "@/components/Files";

/**
 * @deprecated Use iris-based implementation instead.
 */
export const DownloadButton = downloaderBuilder<IButtonProps>(Button);
